<template>
  <v-flex>

    <v-dialog v-model="showTarifasConPrecio" width="800" persistent>
      <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">Tarifas para la regla: {{ reglaSelec ? reglaSelec.nombre : '' }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showTarifasConPrecio = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text>

          <v-row class="mt-12">
            <v-col>
              <v-data-table v-if="reglaSelec !== null" locale="es" dense :headers="headersTarifas" :items="reglaSelec.tarifas"
                :items-per-page="reglaSelec.tarifas.length"
                class="elevation-1 alternating-rows bordered-table mx-4 mb-6" hide-default-footer>



                <template v-slot:no-data>
                  No hay tarifas disponibles
                </template>

              </v-data-table>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-dialog>



  <v-card class="mx-auto" outlined :style="'border: 1px solid grey;'" width="330px" height="370px">
    <v-card-text center>
      <v-row class="mt-2 mb-2" dense justify="center" align="center" align-content="center">
        <h1>
          {{ mesTexto }}
        </h1>
      </v-row>

      <v-row class="mt-2" dense justify="center" align="center" align-content="center">
        <v-spacer> </v-spacer>
        <table class="table table-sm">
          <caption></caption>
          <tr>
            <th id="dias" class="text-center pa-2" v-for="day in daysWeek" v-bind:key="day"
              v-bind:style="{ color: 'black' }">
              {{ day }}
            </th>
          </tr>
          <tr v-for="(row, indexrow) in 6" :key="row">
            <td id="dias" class="text-center pa-0" v-for="(day, indexday) in daysWeek" v-bind:key="day"
              v-bind:style="{ color: 'black' }">

              <v-chip v-if="_mostrardia(indexrow, indexday)" label
                style="width: 35px; height: 35px; display: flex; align-items: center; justify-content: center;"
                :color="_getColorDia(indexrow, indexday)" link @click="_goToDiario(indexrow, indexday)">
                <h4 v-bind:style="{ color: 'white' }">
                  {{ _valueMes(indexrow, indexday) }}
                </h4>
              </v-chip>

            </td>
          </tr>
        </table>
        <v-spacer> </v-spacer>
      </v-row>
    </v-card-text>
  </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  data: () => ({
    cargandoMes: false,
    monthNames: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    daysWeek: ["L", "M", "X", "J", "V", "S", "D"],

    headersTarifas: [
      { text: 'REGIMEN', value: 'regimen_titulo' },
      { text: 'HABITACION-CARACTERISTICA', value: 'habitacion_caracteristica_titulo' },
      { text: 'PRECIO', value: 'precio', width: '200px' },
    ],

    showTarifasConPrecio: false,

  }),

  props: {
    year: {},
    month: {},
  },

  watch: {

  },

  mounted() {

  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorFondoDialog",
      "colorBarraFormulario",
      "tiposCliente",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("reglas", ["reglas", "reglaSelec"]),


    mesTexto() {
      return this.monthNames[this.month - 1];
    },

    totalDaysOfMonth() {
      return new Date(this.year, this.month, 0).getDate();
    },
  },

  methods: {
    ...mapMutations("reglas", ["setReglaSelec"]),

    _getColorTemporada(nombreRegla) {
      switch (nombreRegla) { 
        case 'Temporada Baja':
          return 'green';
        case 'Temporada Media':
          return 'blue';
        case 'Temporada Alta':
          return 'orange';
        case 'Temporada Especial':
          return 'yellow';
        case 'Cierre':
          return 'red';
      }
    },


    _goToDiario(indexrow, indexday) {
      let dia = this._valueMes(indexrow, indexday);
      let fecha = this._valorFecha(this.year, this.month, dia);
     
      let regla = this._reglaCoincidentePorFecha(fecha);
      if (regla) {
        this.setReglaSelec(regla);
        this.showTarifasConPrecio = true;
        console.log('regla:', regla);
      }else{
        this.setReglaSelec(null);
        this.showTarifasConPrecio = false;
      }
    },

    letterDay(day) {
      return day.substr(0, 3);
    },

    dayOfWeek(year, month, day) {
      return new Intl.DateTimeFormat("es-ES", { weekday: "long" })
        .format(new Date(year, month, day))
        .substring(0, 3);
    },

    _valueMes(indexrow, indexday) {
      return indexrow * 7 + (indexday + 1) - this.firstDayPosition();
    },

    _valorFecha(y, m, d) {
      if (y != null) {
        let fecha = y.toString();
        if (m < 10) {
          fecha = fecha + "-0" + m.toString();
        } else {
          fecha = fecha + "-" + m.toString();
        }
        if (d < 10) {
          fecha = fecha + "-0" + d.toString();
        } else {
          fecha = fecha + "-" + d.toString();
        }
        return fecha;
      }
    },

    _valueDisponibilidad(indexrow, indexday) {
      return "-";
    },

    _getColorDia(indexrow, indexday) {
      let dia = this._valueMes(indexrow, indexday);
      let fecha = this._valorFecha(this.year, this.month, dia);
     
      let regla = this._reglaCoincidentePorFecha(fecha);
      if (regla) {
        return this._getColorTemporada(regla.nombre);
      }
      return "grey";
    },

    _reglaCoincidentePorFecha(fecha) {
      const diaSemana = new Date(fecha).getUTCDay(); // 0 = Domingo, 1 = Lunes, ..., 6 = Sábado
      
      return this.reglas.find(regla => {
        const fechaDesde = new Date(regla.fecha_desde);
        const fechaHasta = new Date(regla.fecha_hasta);
        const fechaRevisar = new Date(fecha);

        // Verificar si la fecha está dentro del rango
        const dentroDelRango = fechaRevisar >= fechaDesde && fechaRevisar <= fechaHasta;

        // Verificar si el día de la semana está dentro de los días permitidos
        const diasPermitidos = (() => {
          if (regla.dia_desde <= regla.dia_hasta) {
            return Array.from({ length: 7 }, (_, i) => i).slice(regla.dia_desde, regla.dia_hasta + 1);
          } else {
            // Manejar el caso donde dia_hasta es menor que dia_desde
            return [
              ...Array.from({ length: 7 }, (_, i) => i).slice(regla.dia_desde),
              ...Array.from({ length: 7 }, (_, i) => i).slice(0, regla.dia_hasta + 1)
            ];
          }
        })();

        const diaEstaPermitido = diasPermitidos.includes(diaSemana);
       
        
        return dentroDelRango && diaEstaPermitido;
        
      });
    },

    _mostrardia(indexrow, indexday) {
      if (indexrow == 0 && indexday < this.firstDayPosition()) return false;
      if (this._valueMes(indexrow, indexday) > this.totalDaysOfMonth)
        return false;
      return true;
    },

    firstDayPosition() {
      return new Date(this.year, this.month - 1, 1).getUTCDay();
    },
  },
};
</script>

<style scoped></style>
